module.exports = __webpack_public_path__ + "static/media/IntroToAPIs.43968569.png";